/**
 * vion-icon v1.0.1
 * (c) 2023 yangling
 * @license MIT
 */

import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createElementVNode } from 'vue';

var Group = defineComponent({
  name: "Group",
  props: {
    color: String,
    size: String
  },
  emits: ["click"],
  setup: function setup(props, ctx) {
    var iconStyle = computed(function () {
      return {
        display: "inline-block",
        fontSize: props.size,
        color: props.color,
        width: "1em",
        height: "1em",
        lineHeight: "1em"
      };
    });
    var click = function click(e) {
      return ctx.emit("click", e);
    };
    return {
      iconStyle: iconStyle,
      click: click
    };
  }
});
Group.install = function (app) {
  app.component(Group.name, Group);
};

var _hoisted_1 = /* @__PURE__ */createElementVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9326 18.5994C11.9326 15.5618 14.395 13.0994 17.4326 13.0994C20.4702 13.0994 22.9326 15.5618 22.9326 18.5994C22.9326 21.6369 20.4702 24.0994 17.4326 24.0994C14.395 24.0994 11.9326 21.6369 11.9326 18.5994ZM17.4326 9.09937C12.1859 9.09937 7.93261 13.3527 7.93261 18.5994C7.93261 23.8461 12.1859 28.0994 17.4326 28.0994C22.6793 28.0994 26.9326 23.8461 26.9326 18.5994C26.9326 13.3527 22.6793 9.09937 17.4326 9.09937ZM31.8269 23.4858C31.8269 21.608 33.3491 20.0858 35.2269 20.0858C37.1046 20.0858 38.6269 21.608 38.6269 23.4858C38.6269 25.3635 37.1046 26.8858 35.2269 26.8858C33.3491 26.8858 31.8269 25.3635 31.8269 23.4858ZM35.2269 16.0858C31.14 16.0858 27.8269 19.3988 27.8269 23.4858C27.8269 27.5727 31.14 30.8858 35.2269 30.8858C39.3138 30.8858 42.6269 27.5727 42.6269 23.4858C42.6269 19.3988 39.3138 16.0858 35.2269 16.0858ZM28.8469 39.3907L28.5081 39.6688C25.8647 36.4482 21.9422 34.4279 17.578 34.4279H17.276C12.9118 34.4279 8.98934 36.4482 6.34594 39.6688L3.25403 37.1311C6.60748 33.0453 11.638 30.4279 17.276 30.4279H17.578C21.9088 30.4279 25.8812 31.9723 29.0103 34.5403C30.8029 33.5573 32.8861 32.9998 35.0956 32.9998H35.2321H35.2804C38.8932 32.9998 42.1689 34.4905 44.388 36.8953L41.4483 39.6079C39.9962 38.0343 37.7909 36.9998 35.2804 36.9998H35.2321H35.0956C32.6252 36.9998 30.45 38.0015 28.9974 39.5334L28.8469 39.3907Z",
  fill: "currentColor"
})], -1);
var _hoisted_2 = [_hoisted_1];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: "v-icon",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.click && _ctx.click.apply(_ctx, arguments);
    }),
    style: normalizeStyle(_ctx.iconStyle)
  }, _hoisted_2, 4);
}

Group.render = render;

export { Group as default };
